import { memo } from "react";

import { TableHead, TableHeader, TableRow } from "@/components/ui/table/table";

export const ManagementRefundRequestTopTableHeader = memo(() => {
	return (
		<TableHeader>
			<TableRow>
				<TableHead className="w-32">ステータス</TableHead>
				<TableHead className="w-32">希望返金額</TableHead>
				<TableHead className="w-52">ゲストの名前</TableHead>
				<TableHead className="w-52">最終更新日</TableHead>
				<TableHead className="w-96">リクエスト理由・非承認理由</TableHead>
				<TableHead></TableHead>
				<TableHead></TableHead>
			</TableRow>
		</TableHeader>
	);
});

ManagementRefundRequestTopTableHeader.displayName = "ManagementRefundRequestTopTableHeader";
